module.exports = __webpack_public_path__ + "static/media/RHAInSwingDark.43562306.svg";